

export const routes = {
    RE_ROUTE: {
        METHOD: 'POST',
        URL: '/reRouteList',
    },
    DELETE_NUMBER: {
        METHOD: 'POST',
        URL: '/blockNumber/delete',
    },
    ADD_RE_ROUTE: {
        METHOD: 'POST',
        URL: '/reRouteCreate',
    },
}